import { Component, OnInit } from '@angular/core';
import { StaffService } from '../services/staff.service';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import{ UserService } from '../services/user.service';
import { filter } from 'rxjs/operators';
// import { SnotifyService } from '../../../node_modules/ng-snotify';
import { ResultService } from '../services/result.service';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-staff-evaluation',
  templateUrl: './staff-evaluation.component.html',
  styleUrls: ['./staff-evaluation.component.css']
})
export class StaffEvaluationComponent implements OnInit {
  public questions;
  public n = 0;
  public myForm : FormGroup;
  public display = false;
  public sub_id;
  public co_id;
  public staffDetails;
  public staffLastName;
  public staffOtherNames;
  public staffPassport;
  public staff_id;
  public message;
  public messageExists = false;
  public term_id;
  public r_id;
  public allStaff;
  public selectedStaff;
  public allCourses;
  public evalCourse;
  constructor(private _staffService : StaffService,private fb : FormBuilder,private router : Router,
    private route : ActivatedRoute,private _userService : UserService,
    private _resultService : ResultService, public log: LogService) {
    let controlVar = {};
    this._staffService.getStaffEvaluationQuestions().subscribe(data => {
      //console.log(data);
      this.questions = data;
      for(let x in data){
        for(let y in data[x]){
          controlVar[ "q" + data[x][y].eval_id] = [];
          
        }
      }
       this.myForm = this.fb.group(controlVar);
       this.display = true;
    })
      this.route.paramMap.subscribe((params : ParamMap) => {
      this.sub_id = params.get('sub_id');
      this.co_id = params.get('co_id');
      this.r_id = params.get('r_id');
      this.sub_id = this.sub_id.substr(1, this.sub_id.length - 1);
      this.co_id = this.co_id.substr(1, this.co_id.length - 1);
      this.r_id = this.r_id.substr(1, this.r_id.length - 1);
    })
   }

  ngOnInit() { 
    this.log
      .addLog({
      action: "Access",
      component: "Staff Evaluation",
      details: `Accessed Staff Evaluation`
    }).subscribe(data => { });
    //get all courses
    this._resultService.loadAllCourses().subscribe(data=>{
      this.allCourses = data;
       //display current course being evaluated
      //  console.log(this.allCourses);
      let c = this.allCourses.filter(x => x.co_id == this.co_id);
      this.evalCourse = c[0].title;
    })
   
    this._staffService.getStaffDetails().subscribe(data => {
      this.staffDetails = data.filter(x => x.sub_id == this.sub_id);
      if(this.staffDetails[0] == undefined){
        this.messageExists = true;
        this.message = "No staff has been assigned to this course";
      }else{
        this.staffLastName = this.staffDetails[0].lastname;
        this.staffOtherNames = this.staffDetails[0].middlename + " " + this.staffDetails[0].firstname;
        this.staffPassport = this.staffDetails[0].passport;
        this.staff_id = this.staffDetails[0].staff_id;
      }
      
    });

    this._userService.getUserData().subscribe(data => {
        this.term_id = data.term_id;
    })

    //get all staff
    this._staffService.getAllStaff().subscribe( data=> {
      this.allStaff = data;
    })
   
  }

  saveEval(evalInfo){
    if(this.staff_id == undefined){
      this.staff_id = this.selectedStaff;
    }
    let fullDetails = { 
      staff_id : this.staff_id,
      co_id : this.co_id,
      term_id : this.term_id,
      evalInfo : evalInfo,
      r_id : this.r_id
    }
    this._staffService.saveEvaluationQuestions(fullDetails).subscribe(data => {
      if(data.success){
        this.log
          .addLog({
          action: "Save",
          component: "Staff Evaluation",
          details: `Saved Evaluation (Staff - ${this.staff_id})`
        }).subscribe(data => { });
        // this.Notify.simple('Successful!',{
        //   timeout:2000,
        //   pauseOnHover:false,
        //   showProgressBar:false,
        // })
      }else{
        // this.Notify.simple('Failed! Please try again',{
        //   timeout:2000,
        //   pauseOnHover:false,
        //   showProgressBar:false,
        // })
      }
    })
     
  }
  loadPassport(selectedStaffId){
      let sp = this.allStaff.filter(x => x.staff_id == selectedStaffId);
      this.staffPassport = sp[0].passport;
      // console.log(this.staffPassport);
  }

}
